import React, { useState, useEffect } from "react";
import "./DarkMode.css";
import { RouterApp } from "./Router/Router";
import { Navbar } from "./componets/Navbar";

export const App = () => {
  const [theme, setTheme] = useState("dark");

  const toggleTheme = () => {
    console.log("Tema cambiado");
    if (theme === "light") {
      setTheme("dark");
    } else {
      setTheme("light");
    }
    console.log("working");
  };

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  return (
    <div className={`App ${theme}`}>
     <Navbar mode={toggleTheme} />
      <RouterApp />
    </div>
  );
};
